import React from 'react';

class Divider extends React.Component {
    render () {
        const { children, className, ...props } = this.props;
        return (
        <div role="separator" className={`tde-divider ` + (className || '')} {...props}></div>
        )
    }
}

export default Divider
